import { useCallback } from 'react';
import { useSelector, useStore, shallowEqual } from 'react-redux';
import useAsync from './useAsync';
import queryCredoEligibility from '../data/queryCredoEligibility';
import getCredoEligibility from '../requests/getCredoEligibility';
const useQueryCredoEligibility = function () {
  let {
    forceFetch = false,
    ownProps: {
      feature
    } = {},
    ownProps
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let {
    defer = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const store = useStore();
  const useAsyncFn = useCallback(() => {
    const {
      promise
    } = queryCredoEligibility({
      store,
      ownProps
    });
    return promise;
  }, [store, ownProps]);
  const result = useSelector(state => getCredoEligibility(state, feature), shallowEqual);
  return useAsync(useAsyncFn, [forceFetch ? Math.random() : null, defer], {
    forceFetch,
    defaults: {
      data: result,
      loading: Object.keys(result).length === 0 || forceFetch,
      error: result.error
    },
    defer
  });
};
export default useQueryCredoEligibility;